import React from 'react'
import luggage from '../../../images/packing.png'
const PackingTips = () => {
  return (
    <div>
      <p>Here are a few packing tips:  </p>
      <div className='text-center' >
      <img  src={luggage} alt='luggage' style={{width:'60px', height:'50px'}}/>
      </div>
      
      <div className='mt-2'>
      <ul>
        <li>Set a date for packing, two days before your trip, so you have time to pack and a time to remember anything you might have forgotten</li>
        <li> Make a checklist of everything you'd like to take on your trip in different sections such as Toiletries, Body Care, Clothes</li>
        <li>Always pack clothes first with your first wear on top</li>
        <li>Place heavy items at the base of your luggage</li>
        <li>Get an extra tote bag incase of neccesity</li>
        <li>Carry a reusable water bottle</li>
      </ul>
      </div>
     
    </div>
  )
}

export default PackingTips
